import { graphql } from 'react-relay';

import { InternalUserWindowPaginator_query$key } from '../../../relay/__generated__/InternalUserWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const InternalUserWindowPaginator_query = graphql`
  fragment InternalUserWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: MATInternalUserFilter }
    order: { type: MATInternalUserOrder, defaultValue: { dateJoined: DESC } }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int, defaultValue: 10 }
  )
  @refetchable(queryName: "InternalUserWindowPaginatorRefreshQuery") {
    internalUsers(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...InternalUserConnectionDataTable_internalUserConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<InternalUserWindowPaginator_query$key>, 'fragment'>;

const InternalUserWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={InternalUserWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.internalUsers.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default InternalUserWindowPaginator;
